import { render, staticRenderFns } from "./BCOrderRemarkModal.vue?vue&type=template&id=70740188&scoped=true"
import script from "./BCOrderRemarkModal.vue?vue&type=script&lang=ts"
export * from "./BCOrderRemarkModal.vue?vue&type=script&lang=ts"
import style0 from "./BCOrderRemarkModal.vue?vue&type=style&index=0&id=70740188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70740188",
  null
  
)

export default component.exports